import pb from '../lib/pocketbase';

export async function getProveedores(page, perPage) {
  return await pb.collection('proveedor').getList(page, perPage, {
    sort: '-created', // Ordenar por fecha de creación descendente
    $autoCancel: false,
    expand: '' // Ajusta si necesitas expandir relaciones
  });
}

export async function createProveedor(proveedor) {
  return await pb.collection('proveedor').create(proveedor);
}

export async function updateProveedor(id, proveedor) {
  return await pb.collection('proveedor').update(id, proveedor);
}

export async function deleteProveedor(id) {
  return await pb.collection('proveedor').delete(id);
}
